/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerPaymentBillTypeEnum;

(function (BrokerPaymentBillTypeEnum) {
  BrokerPaymentBillTypeEnum["JOVE_BILLING"] = "jove_billing";
  BrokerPaymentBillTypeEnum["AGENT_BILLING"] = "agent_billing";
  BrokerPaymentBillTypeEnum["BANK_TRANSFER"] = "bank_transfer";
  BrokerPaymentBillTypeEnum["DIRECT_DEBIT"] = "direct_debit";
})(BrokerPaymentBillTypeEnum || (BrokerPaymentBillTypeEnum = {}));